import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Employee.api';

export const uploadEmployeeMasterRequest = (fileData) => ({
  type: actionTypes.UPLOAD_EMPLOYEE_MASTER_REQUEST,
  payload: fileData,
});

export const uploadEmployeeMasterSuccess = (message) => ({
  type: actionTypes.UPLOAD_EMPLOYEE_MASTER_SUCCESS,
  payload: message,
});

export const uploadEmployeeMasterFailure = (error) => ({
  type: actionTypes.UPLOAD_EMPLOYEE_MASTER_FAILURE,
  payload: error,
});

export const uploadEmployeeMasterFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadEmployeeMasterRequest(fileData));
    try {
      const response = await api.uploadEmployeeMaster(fileData);
      dispatch(uploadEmployeeMasterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(uploadEmployeeMasterFailure(error));
      return { success: false, message: error };
    }
  };
};

export const uploadEmployeeDynamicUpdateRequest = (fileData) => ({
  type: actionTypes.UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_REQUEST,
  payload: fileData,
});

export const uploadEmployeeDynamicUpdateSuccess = (message) => ({
  type: actionTypes.UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_SUCCESS,
  payload: message,
});

export const uploadEmployeeDynamicUpdateFailure = (error) => ({
  type: actionTypes.UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_FAILURE,
  payload: error,
});

export const uploadEmployeeDynamicUpdateFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadEmployeeDynamicUpdateRequest(fileData));
    try {
      const response = await api.uploadEmployeeDynamicUpdate(fileData);
      dispatch(uploadEmployeeDynamicUpdateSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(uploadEmployeeDynamicUpdateFailure(error));
      return { success: false, message: error };
    }
  };
};

export const getEmployeesRequest = (current_month) => ({
  type: actionTypes.GET_EMPLOYEES_REQUEST,
  payload: current_month,
});

export const getEmployeesSuccess = (Employees) => ({
  type: actionTypes.GET_EMPLOYEES_SUCCESS,
  payload: Employees,
});

export const getEmployeesFailure = (error) => ({
  type: actionTypes.GET_EMPLOYEES_FAILURE,
  payload: error,
});

export const getEmployees = (current_month) => {
  return async (dispatch) => {
    dispatch(getEmployeesRequest(current_month));
    try {
      const Employees = await api.fetchEmployees(current_month);
      const list = Array.isArray(Employees)
        ? Employees
        : Array.isArray(Employees?.data)
          ? Employees.data
          : Array.isArray(Employees?.employees)
            ? Employees.employees
            : [];
      dispatch(getEmployeesSuccess(list));
      return { success: true, data: list };
    } catch (error) {
      dispatch(getEmployeesFailure(error));
      return { success: false, message: error, data: [] };
    }
  };
};

export const getReportsOfEmployeeBranchTransferAction = (current_month, client_id, unit_id = null) => {
  return async () => {
    try {
      const data = await api.getReportsOfEmployeeBranchTransfer(current_month, client_id, unit_id);
      const transfers = Array.isArray(data?.transfers) ? data.transfers : [];
      return { success: true, data: transfers };
    } catch (error) {
      const message =
        typeof error === 'string' ? error : error?.message || 'Failed to fetch employee transfer report';
      return { success: false, message };
    }
  };
};

export const getEmployeeImportantBackupReportAction = (current_month, client_id, unit_id = null) => {
  return async () => {
    try {
      const data = await api.getEmployeeImportantBackupReport(current_month, client_id, unit_id);
      const rows = Array.isArray(data) ? data : [];
      return { success: true, data: rows };
    } catch (error) {
      const message =
        typeof error === 'string' ? error : error?.message || 'Failed to load employee master updates report';
      return { success: false, message };
    }
  };
};

export const updateEmployeesRequest = (id, EmployeesData) => ({
  type: actionTypes.UPDATE_EMPLOYEES_REQUEST,
  payload: { id, EmployeesData },
});

export const updateEmployeesSuccess = (message) => ({
  type: actionTypes.UPDATE_EMPLOYEES_SUCCESS,
  payload: message,
});

export const updateEmployeesFailure = (error) => ({
  type: actionTypes.UPDATE_EMPLOYEES_FAILURE,
  payload: error,
});

export const updateEmployeesById = (id, EmployeesData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    EmployeesData.updated_by = user.user_name;

    dispatch(updateEmployeesRequest(id, EmployeesData));
    try {
      const response = await api.updateEmployees(id, EmployeesData);
      dispatch(updateEmployeesSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateEmployeesFailure(error));
      return { success: false, message: error };
    }
  };
};
export const deleteEmployeesRequest = (id) => ({
  type: actionTypes.DELETE_EMPLOYEES_REQUEST,
  payload: id,
});

export const deleteEmployeesSuccess = (message) => ({
  type: actionTypes.DELETE_EMPLOYEES_SUCCESS,
  payload: message,
});

export const deleteEmployeesFailure = (error) => ({
  type: actionTypes.DELETE_EMPLOYEES_FAILURE,
  payload: error,
});

export const deleteEmployeesById = (id) => {
  return async (dispatch) => {
    dispatch(deleteEmployeesRequest(id));
    try {
      const response = await api.deleteEmployees(id);
      dispatch(deleteEmployeesSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteEmployeesFailure(error));
      return { success: false, message: error };
    }
  };
};

export const multiDaleteEmployeeMasterRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_UNIT_REQUEST,
  payload: ids,
});

export const multiDaleteEmployeeMasterSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_UNIT_SUCCESS,
  payload: message,
});

export const multiDaleteEmployeeEmployeeFailure = (error) => ({
  type: actionTypes.MULTIDELETE_UNIT_FAILURE,
  payload: error,
});

export const multiDeleteEmployeeMasterFile = (ids) => {
  console.log(ids);
  return async (dispatch) => {
    dispatch(multiDaleteEmployeeMasterRequest(ids));
    try {
      const response = await api.multiDeleteEmployeeMaster(ids);
      dispatch(multiDaleteEmployeeMasterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteEmployeeEmployeeFailure(error));
      return { success: false, message: error };
    }
  };
};
